        <app-page-shell>
            <p-toast position="top-center"></p-toast>
            <app-page-hero eyebrow="Finance Admin" title="Accounting Period Locks"
                subtitle="Create, edit, and release accounting or tax period locks with audit reasons."></app-page-hero>

            <app-page-form-section icon="pi pi-lock" [title]="draft.periodLockId ? 'Edit Period Lock' : 'Create Period Lock'" subtitle="Manual posting, allocation, reversal, and document-date changes must respect active locks.">
                <div class="form-grid">
                    <div><label>Lock type</label><p-select [options]="lockTypes" [(ngModel)]="draft.lockType"></p-select></div>
                    <div><label>Start date</label><p-datePicker [(ngModel)]="startDate" dateFormat="yy-mm-dd"></p-datePicker></div>
                    <div><label>End date</label><p-datePicker [(ngModel)]="endDate" dateFormat="yy-mm-dd"></p-datePicker></div>
                    <div><label>Status</label><p-select [options]="lockStatuses" optionLabel="label" optionValue="value" [(ngModel)]="draft.locked"></p-select></div>
                    <div class="wide"><label>Reason</label><input pInputText [(ngModel)]="draft.reason" placeholder="Reason required for audit" /></div>
                </div>
                <div class="actions-row">
                    <p-button label="Clear" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="resetDraft()"></p-button>
                    <p-button [label]="draft.periodLockId ? 'Update Lock' : 'Create Lock'" icon="pi pi-save" (click)="save()" [disabled]="!draft.reason || !startDate || !endDate"></p-button>
                </div>
            </app-page-form-section>

            <app-page-data-panel title="Current Locks" [resultText]="locks.length + ' locks'">
                <p-table [value]="locks" responsiveLayout="stack">
                    <ng-template pTemplate="header"><tr><th>Type</th><th>Period</th><th>Status</th><th>Reason</th><th>Created</th><th>Actions</th></tr></ng-template>
                    <ng-template pTemplate="body" let-lock>
                        <tr>
                            <td>{{ lock.lockType }}</td>
                            <td>{{ lock.periodStartDate | date:'yyyy-MM-dd' }} - {{ lock.periodEndDate | date:'yyyy-MM-dd' }}</td>
                            <td>{{ lock.locked === false ? 'Unlocked' : 'Locked' }}</td>
                            <td>{{ lock.reason }}</td>
                            <td>{{ lock.createdAt | date:'short' }}</td>
                            <td>
                                <div class="row-actions">
                                    <p-button label="Edit" icon="pi pi-pencil" size="small" severity="secondary" [outlined]="true" (click)="edit(lock)"></p-button>
                                    <p-button label="Unlock" icon="pi pi-unlock" size="small" severity="warn" [outlined]="true" (click)="unlock(lock)" [disabled]="lock.locked === false"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-page-data-panel>
        </app-page-shell>
    

